/**
 * QLF Carousel Manager
 * Zentrale Verwaltung für alle QLF Carousel Sections
 * Unterstützt: qlf-experts, qlf-social-proof-testimonials, qlf-trusted-shops-slider
 */
(function () {
  'use strict';

  var initialized = {};

  function initCarouselSection(root) {
    if (!root || initialized[root.id]) return;
    initialized[root.id] = true;

    var carouselEl = root.querySelector('.carousel');
    if (!carouselEl) return;

    var navContainer = root.querySelector('.qlf-experts-nav-container');
    var flkty = null;

    // ===== NEU: Prevent initial layout shift =====
    // Reserve space immediately, make nav container visible but empty
    if (navContainer) {
      navContainer.style.minHeight = '40px';
      navContainer.style.opacity = '0';
    }

    // Hide carousel during init to prevent flicker
    carouselEl.style.opacity = '0';
    // ==============================================

    var isMobile = function () {
      return window.innerWidth < 1024;
    };

    var moveNavigationToContainer = function () {
      if (!navContainer) return;

      var dots = carouselEl.querySelector('.flickity-page-dots');
      var prevBtn = carouselEl.querySelector('.flickity-prev-next-button.previous');
      var nextBtn = carouselEl.querySelector('.flickity-prev-next-button.next');

      // Move elements to container
      if (dots && dots.parentNode !== navContainer) {
        navContainer.appendChild(dots);
      }
      if (prevBtn && prevBtn.parentNode !== navContainer) {
        navContainer.appendChild(prevBtn);
      }
      if (nextBtn && nextBtn.parentNode !== navContainer) {
        navContainer.appendChild(nextBtn);
      }

      // Show/hide navigation based on slide count
      if (flkty) {
        var hasMultipleSlides = flkty.slides && flkty.slides.length > 1;

        if (hasMultipleSlides) {
          // ===== NEU: Smooth fade-in =====
          navContainer.style.opacity = '1';
          // ================================
          navContainer.style.setProperty('display', 'flex', 'important');
          if (dots) dots.style.setProperty('display', 'flex', 'important');
          if (prevBtn) prevBtn.style.setProperty('display', 'block', 'important');
          if (nextBtn) nextBtn.style.setProperty('display', 'block', 'important');
        } else {
          navContainer.style.display = 'none';
        }
      }
    };

    var updateDraggable = function () {
      if (!flkty) return;

      try {
        var shouldDrag = isMobile();

        if (flkty.options.draggable !== shouldDrag) {
          flkty.options.draggable = shouldDrag;

          if (typeof flkty.updateDraggable === 'function') {
            flkty.updateDraggable();
          }
        }

        moveNavigationToContainer();
      } catch (e) {
        console.warn('Error updating draggable:', e);
      }
    };

    var initFlickity = function () {
      if (typeof Flickity === 'undefined') {
        setTimeout(initFlickity, 100);
        return;
      }

      flkty = Flickity.data(carouselEl);

      if (!flkty) {
        setTimeout(initFlickity, 100);
        return;
      }

      // Initial setup
      updateDraggable();
      moveNavigationToContainer();

      setTimeout(function () {
        carouselEl.style.opacity = '1';
        if (navContainer) {
          navContainer.style.opacity = '1';
        }
      }, 100);

      flkty.on('ready', function () {
        moveNavigationToContainer();
        updateDraggable();

        carouselEl.style.opacity = '1';
        if (navContainer) {
          navContainer.style.opacity = '1';
        }
      });

      flkty.on('change', function () {
        moveNavigationToContainer();
      });

      flkty.on('resize', function () {
        moveNavigationToContainer();
        updateDraggable();
      });

      flkty.on('settle', function () {
        moveNavigationToContainer();
      });

      // MutationObserver to catch when Flickity re-renders navigation
      if ('MutationObserver' in window && navContainer) {
        var navObserver = new MutationObserver(function (mutations) {
          var shouldMove = false;

          mutations.forEach(function (mutation) {
            // Check if navigation elements were added back to carousel
            mutation.addedNodes.forEach(function (node) {
              if (
                node.classList &&
                (node.classList.contains('flickity-page-dots') ||
                  node.classList.contains('flickity-prev-next-button'))
              ) {
                shouldMove = true;
              }
            });
          });

          if (shouldMove) {
            // Delay to let Flickity finish its rendering
            setTimeout(moveNavigationToContainer, 10);
          }
        });

        // Observe carousel for navigation element changes
        navObserver.observe(carouselEl, {
          childList: true,
          subtree: false
        });
      }
    };

    // Start Flickity initialization
    initFlickity();

    // Height synchronization
    var getCards = function () {
      return root.querySelectorAll('.experts-card');
    };

    function raf(fn) {
      return window.requestAnimationFrame ? requestAnimationFrame(fn) : setTimeout(fn, 0);
    }

    function debounce(fn, wait) {
      var t;
      return function () {
        clearTimeout(t);
        t = setTimeout(fn, wait);
      };
    }

    function isElementVisible(el) {
      if (!el) return false;
      var style = window.getComputedStyle(el);
      return (
        style.display !== 'none' &&
        style.visibility !== 'hidden' &&
        style.opacity !== '0' &&
        !el.hasAttribute('data-qlf-pending')
      );
    }

    function forceReflow(element) {
      if (!element) return;
      void element.offsetHeight;
    }

    function updateFlickitySafari(carousel) {
      if (!carousel || typeof Flickity === 'undefined') return;

      var flkty = Flickity.data(carousel);
      if (!flkty) return;

      forceReflow(carousel);

      setTimeout(function () {
        flkty.resize();
        flkty.reloadCells();
      }, 50);

      setTimeout(function () {
        flkty.resize();
        flkty.reloadCells();
      }, 200);

      setTimeout(function () {
        flkty.resize();
        flkty.reloadCells();
      }, 500);
    }

    var syncing = false;

    function syncHeights() {
      if (syncing) return;

      if (!isElementVisible(root)) {
        return;
      }

      syncing = true;
      raf(function () {
        var list = getCards();
        if (!list || !list.length) {
          syncing = false;
          return;
        }
        var max = 0;
        list.forEach(function (card) {
          card.style.minHeight = '';
        });

        forceReflow(root);

        list.forEach(function (card) {
          max = Math.max(max, card.offsetHeight);
        });
        list.forEach(function (card) {
          card.style.minHeight = max + 'px';
        });
        carouselEl.style.setProperty('--qlf-carousel-min-height', max + 'px');
        syncing = false;
      });
    }

    var debouncedSync = debounce(syncHeights, 100);
    var debouncedUpdateDraggable = debounce(updateDraggable, 100);
    var debouncedMoveNav = debounce(moveNavigationToContainer, 50);

    // Event Listener für delayed content
    window.addEventListener('qlf:delayedContentVisible', function (e) {
      if (root.hasAttribute('data-qlf-delayed-group')) {
        setTimeout(function () {
          forceReflow(root);
          forceReflow(carouselEl);
          updateFlickitySafari(carouselEl);
          syncHeights();
          moveNavigationToContainer();

          setTimeout(syncHeights, 400);
          setTimeout(syncHeights, 800);
        }, 100);
      }
    });

    // IntersectionObserver
    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting && entry.intersectionRatio > 0.1) {
              if (flkty) {
                setTimeout(function () {
                  flkty.resize();
                  syncHeights();
                  moveNavigationToContainer();
                }, 100);
              }
            }
          });
        },
        { threshold: [0.1] }
      );

      observer.observe(root);
    }

    // Window events
    if (document.readyState === 'complete') {
      syncHeights();
    } else {
      window.addEventListener('load', syncHeights);
    }

    // Resize listener
    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        debouncedSync();
        debouncedUpdateDraggable();
        debouncedMoveNav();
      }, 150);
    });

    // Image loads
    root.querySelectorAll('img').forEach(function (img) {
      if (!img.complete) img.addEventListener('load', debouncedSync);
    });

    // ResizeObserver for cards
    if ('ResizeObserver' in window) {
      var ro = new ResizeObserver(debouncedSync);
      getCards().forEach(function (card) {
        ro.observe(card);
      });
    }

    // MutationObserver for DOM changes
    if ('MutationObserver' in window) {
      var mo = new MutationObserver(function () {
        debouncedSync();
        debouncedMoveNav();
      });
      mo.observe(root, { childList: true, subtree: true });
    }

    // Multiple sync attempts for Safari
    setTimeout(syncHeights, 100);
    setTimeout(syncHeights, 300);
    setTimeout(syncHeights, 600);
    setTimeout(syncHeights, 1000);
    setTimeout(syncHeights, 1500);
  }

  // Auto-initialize all carousel sections
  function initAll() {
    var selectors = ['.qlf-ts-experts', '.qlf-ts-review-slider'];

    selectors.forEach(function (selector) {
      document.querySelectorAll(selector).forEach(function (section) {
        var container = section.querySelector('[id^="experts-"]');
        if (container) {
          initCarouselSection(container);
        }
      });
    });
  }

  // Initialize on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Re-initialize on Shopify section load (Theme Editor)
  document.addEventListener('shopify:section:load', function (e) {
    setTimeout(initAll, 100);
  });

  // Expose for manual initialization if needed
  window.QLFCarouselManager = {
    init: initCarouselSection,
    initAll: initAll
  };
})();
